import { dateLocale } from "@/lib/utils";
// Mirrors backend draft_to_data (server.py) so the live A4 preview matches the PDF.

export const fmtEur = (n) =>
  n === null || n === undefined || n === "" ? null : `${Math.round(Number(n)).toLocaleString(dateLocale())} €`;

const fmtRange = (mn, mx, suffix = "") => {
  const a = fmtEur(mn), b = fmtEur(mx);
  if (a && b) return `${a} – ${b}${suffix}`;
  return a || b ? (a || b) + suffix : null;
};

export function draftToData(draft, config, audience = "internal") {
  if (!draft || !config) return {};
  const by = {};
  Object.entries(config.tags || {}).forEach(([cat, list]) => {
    by[cat] = Object.fromEntries(list.map((x) => [x.id, x.label]));
  });
  const p = draft.profile || {};
  const c = draft.contract || {};
  const strengths = [
    ...(p.strengths || []).map((i) => by.strengths?.[i] || i),
    ...(p.custom_strengths || []),
  ];
  const showCommercial = audience !== "external" || c.share_commercial;
  const per = c.salary_period === "monthly" ? " / mois" : " / an";
  const notes = [
    ...(draft.career?.experiences || [])
      .filter((e) => e.include !== false && (e.club || e.season))
      .map((e) => `${e.season || ""} — ${e.club || ""}${e.competition ? ` (${e.competition})` : ""}${e.summary ? ` · ${e.summary}` : ""}`),
    ...(draft.career?.highlights || []),
  ];
  const selected = (draft.stats?.selected?.length ? draft.stats.selected : (config.metrics || []).map((m) => m.key)).slice(0, 6);
  const values = draft.stats?.values || {};
  return {
    identity: draft.identity || {},
    season_stats: Object.fromEntries(selected.filter((k) => values[k]).map((k) => [k, values[k]])),
    season_label: draft.stats?.season_label || "",
    strengths: strengths.slice(0, 8).join("\n"),
    styles_line: (p.styles || []).map((i) => by.styles?.[i] || i).join(", ") || null,
    env_line: (p.environments || []).map((i) => by.environments?.[i] || i).join(", ") || null,
    summary: p.summary_approved && p.summary ? p.summary : null,
    notes: notes.slice(0, 8).join("\n"),
    market_value: showCommercial ? fmtRange(c.market_min, c.market_max) : null,
    salary_expectation: showCommercial ? fmtRange(c.salary_min, c.salary_max, per) : null,
    transfer_fee: showCommercial ? c.transfer_fee : null,
    availability: c.availability,
    contract_end_date: c.contract_end_date,
    preferred_market: (c.preferred_markets || []).join(", ") || null,
    sections: {
      ...(draft.sections || {}),
      market_value: (draft.sections?.market_value ?? true) && showCommercial,
      qr_code: (draft.sections?.qr_code ?? true) && draft.contact?.qr?.destination !== "none",
    },
  };
}

export function selectedStatFields(draft, config) {
  const all = config?.metrics || [];
  const sel = draft?.stats?.selected?.length ? draft.stats.selected : all.map((m) => m.key);
  const byKey = Object.fromEntries(all.map((m) => [m.key, m]));
  return sel.slice(0, 6).map((k) => byKey[k]).filter(Boolean);
}
